export default __webpack_public_path__ + "static/media/profile.ed9aaca9.jpg";